import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgMiscAgentFill = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      fillRule="evenodd"
      d="M14 5h-1v2h7v4h2v7h-2v4H4v-4H2v-7h2V7h7V5h-1V2h4v3Zm.586 11H9.274l-.49-.62-1.568 1.24.79 1 .3.38h7.108l1.293-1.293-1.414-1.414-.707.707ZM9.5 11a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMiscAgentFill;
